export default "__VITE_ASSET__BPVdmk1l__"